import { useCallback, useEffect, useState } from "react";

import { applyContentWidth, type ContentWidth, readContentWidth, saveContentWidth } from "./content-width";

/** The Full width choice, picked up again when the tab returns (another Hume app may have changed it). */
export function useContentWidth(): [ContentWidth, (width: ContentWidth) => void] {
  const [width, setWidthState] = useState<ContentWidth>(readContentWidth);

  useEffect(() => {
    const sync = () => {
      if (document.visibilityState !== "visible") return;
      const current = readContentWidth();
      applyContentWidth(current);
      setWidthState(current);
    };
    document.addEventListener("visibilitychange", sync);
    return () => document.removeEventListener("visibilitychange", sync);
  }, []);

  const setWidth = useCallback((next: ContentWidth) => {
    saveContentWidth(next);
    setWidthState(next);
  }, []);

  return [width, setWidth];
}
